module.exports = __webpack_public_path__ + "static/img/12.958fedc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/zh/12.png
// module id = i5xk
// module chunks = 0